//https://netbasal.com/anchors-away-how-to-create-smooth-scrolling-in-angular-a657e0ea9699
import { Directive } from '@angular/core';
import { ScrollSectionDirective } from './scroll-section.directive';

@Directive({
    selector: '[appScrollManager]',
    standalone: true
})
export class ScrollManagerDirective {
   private sections = new Map<string | number, ScrollSectionDirective>();

   scroll(id: string | number) {
      this.sections.get(id)!.scroll();
   }

   register(section: ScrollSectionDirective) {
      this.sections.set(section.id, section);
   }

   remove(section: ScrollSectionDirective) {
      this.sections.delete(section.id);
   }
}

/* USE:
 *
 * <section appScrollManager>
     <nav>
       <button appScrollAnchor="one">One</button>
       <button appScrollAnchor="two">Two</button>
       <button appScrollAnchor="three">Three</button>
     </nav>

     <main>
       <div>
         <h4 appScrollSection="one">One</h4>
         <p>{{ sections[0] }}</p>
       </div>

       <div>
         <h4 appScrollSection="two">Two</h4>
         <p>{{ sections[1] }}</p>
       </div>

       <div>
         <h4 appScrollSection="three">Three</h4>
         <p>{{ sections[2] }}</p>
       </div>
     </main>
   </section>
 *
 * */
